import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import qs from 'qs';
import moment from "moment";
import Paging from "../../components/Paging";
import FormDropdown from '../../components/FormDropdown';
import {SelectPanel, MultiSelect} from "@khanacademy/react-multi-select";
import CustomModal from '../../components/CustomModal'
import CustomModalTetapan from '../../components/CustomModalTetapan'

const NewDate    = moment().format('YYYY-MM-DD')

class Penetapan extends Component {
	constructor(props) {
		super(props);

		this.state = {
            dataReport: [],
            dataKelas: [],
            dataReporttetapan: [],
            kelas_id:"",
			master_id:"",
			user_id: "",
            sortby       :"",
            pageCount    : 0,
            currentPage  : 0,
            partRemeds : [],
            partRemedtetapan : [],
            dataSisAll: [],
            dataSisAllTetapan: [],
            isModalShow  : false,
            isModalShowTetapan  : false,
            isModalShowDelete  : false,
            
			date: "",
			created_by:"",
			isButtonLoading: false,
			isLoading   : false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModal              = this.toggleModal.bind(this)
        this.toggleModalTetapan              = this.toggleModalTetapan.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)
    	this.handleSubmitTetapan = this.handleSubmitTetapan.bind(this);
    	this.handleSubmitHapusTetapan = this.handleSubmitHapusTetapan.bind(this);
        this.handleSelectedChanged = this.handleSelectedChanged.bind(this);
        this.handleSelectedChangedTetapan = this.handleSelectedChangedTetapan.bind(this);
	}

    
    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }

    toggleModalTetapan() {
        this.setState({ isModalShowDelete: ! this.state.isModalShowDelete })
    }

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
    }

    handleSelectedChanged(partRemeds) {
        this.setState({partRemeds});

    }

    handleSelectedChangedTetapan(partRemedtetapan) {
        this.setState({partRemedtetapan});
    }

    handleSubmit() {
        let formData = new FormData();
        const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("created_by", localStorage.SISMART_USER_ID);
		formData.append("master_id", this.state.master_id);
		formData.append("group_id", this.state.group_id);
		formData.append("master_tgl_jatuh_tempo", this.state.master_tgl_jatuh_tempo);
		formData.append("tipe_id", this.state.tipe_id);
		formData.append("master_nominal", this.state.master_nominal);

		const url = this.props.mode === "Tambah" ? "/iuran/master/add" : "/iuran/master/update";

		this.setState({ isButtonLoading: true });

		axios.post(url, formData, config)
			.then(response => {
                
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/masteriuran");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			}); 
	}

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
        });
    };

	loadData() {
		this.setState({isLoading: true, isButtonLoading: true})

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            kelas_id: this.state.kelas_id,
            finance_id: this.props.match.params.master_id,
            sortby: this.state.sortby
        })

        axios.get("/iuran/penetapan_master?" + params)

            .then(response => {
                const result = response.data

                if (result.success === true) {
                    this.setState({
                        dataReport: result.data,
                        dataReporttetapan: result.data_tetapan,
                        isLoading: false,
                        isButtonLoading: false
                    });
                } else {

                    this.setState({
                        dataReport: result.data,
                        dataReporttetapan: result.data_tetapan,
                        isLoading: false,
                        isButtonLoading: false
                    });

                    Alert.error(result.message);
                    this.setState({isLoading: false});
                }

            })

            .catch(error => {
                this.setState({isLoading: false});
                Alert.error("Gagal terhubung ke server!");
            });
	}
    
    loadDataKelas() {
        this.setState({ isButtonLoading: true });
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key: item.kelas_id,
                    value: item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelas: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }
	
	handleSubmitTetapan() {

        const params = qs.stringify({
            finance_id: this.props.match.params.master_id,
            siswa_id:this.state.partRemeds,
            finance_tipe:'Iuran',
            created_by:localStorage.SISMART_USER_ID

        })

        const url ='/siswa/finance/add';
		
		axios
			.post(url, params)
			.then(response => {
				const result = response.data;

				if (result.success) {
                    Alert.success(result.message);
                    this.loadData()
                    this.state.isModalShow=false;
                    this.partRemeds=[];
					
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
                            this.state.isModalShow=false;
                            this.partRemeds=[];
							Alert.error(item);

							return true;
						});
					} else {
                        this.state.isModalShow=false;
                        this.partRemeds=[];
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
    }
	
	handleSubmitHapusTetapan() {
        console.log(this.state.partRemedtetapan)
        const params = qs.stringify({
            finance_id: this.props.match.params.master_id,
            siswa_id:this.state.partRemedtetapan,
            finance_tipe:'Iuran',
            created_by:localStorage.SISMART_USER_ID

        })

        const url ='/siswa/finance/delete';
		
		axios
			.post(url, params)
			.then(response => {
				const result = response.data;

				if (result.success) {
                    Alert.success(result.message);
                    this.loadData()
                    this.state.isModalShowDelete=false;
                    this.partRemeds=[];
					
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
                            this.state.isModalShowDelete=false;
                            this.partRemeds=[];
							Alert.error(item);

							return true;
						});
					} else {
                        this.state.isModalShowDelete=false;
                        this.partRemeds=[];
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
    }
    
	componentDidMount() {
		this.loadData();
        this.loadDataKelas();
	}

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search || 
            prevState.kelas_id !== this.state.kelas_id || prevState.sortby !== this.state.sortby) {
            this.loadData()
        }
    }

	render() {
        const dataSisAll = this.state.dataReport.map(item => ({
            value: item.siswa_id,
            label: item.user_nama+' - '+item.kelas_nama
        }));

        const dataSisAllTetapan = this.state.dataReporttetapan.map(item => ({
            value: item.siswa_id,
            label: item.user_nama+' - '+item.kelas_nama
        }));
        
        const {partRemeds} = this.state;
        const {partRemedtetapan} = this.state;
		return (
			<div className="col-sm-12">
                

                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitTetapan}
                    modalHeaderText="Data Insert Penetapan"
                    modalBodyText={"Konfirmasi Penetapan Iuran"}
                    modalSubmitText="Ya" />

                <CustomModalTetapan
                    isShow={this.state.isModalShowDelete}
                    toggleModalTetapan={this.toggleModalTetapan}
                    handleSubmitHapusTetapan={this.handleSubmitHapusTetapan}
                    modalHeaderText="Data Hapus Penetapan Iuran"
                    modalBodyText={"Konfirmasi Hapus Penetapan Iuran"}
                    modalSubmitText="Ya" />

				<div className="card">
                    <div className="card-header">
                        Master Iuran
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-12">
                                <label className="form-control-label">Nama Group : </label> <label>{atob(this.props.match.params.group_nama)}</label>
                            </div>
                        </div>
						<div className="form-group row">
							<label className="col-md-1 form-control-label"style={{marginTop:3}}>Kelas : </label>
                             <div className="col-md-2">
                                <FormDropdown
                                    items={this.state.dataKelas}
                                    onChange={this.handleChange}
                                    style={{borderRadius:3}}
                                    value={this.state.kelas_id.toString()}
                                    name="kelas_id"
                                />
                            </div>
						</div>
                        <hr></hr>
                        
                        <div className="form-group row">
                            <div className="col-md-6 ">
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.dataReport.length === 0 ? "Data tidak ditemukan..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Belum Ditetapkan
                                                    
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-md btn-primary pull-right"
                                                            disabled={this.state.isButtonLoading && "disabled"}
                                                            // onClick={this.handleSubmit}
                                                            onClick={() => {
                                                                this.toggleModal();
                                                            }}
                                                        >
                                                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                                                        </button>
                                                </div>

                                                <SelectPanel
                                                    options={dataSisAll}
                                                    onSelectedChanged={this.handleSelectedChanged}
                                                    hasSelectAll
                                                    focusIndex={1}
                                                    selected={partRemeds}
                                                    disableSearch={false}
                                                />
                                            </div>
                                        )
                                    )
                                }
                            </div>

                            <div className="col-md-6 ">
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.dataReporttetapan.length === 0 ? "Data tidak ditemukan..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Sudah Ditetapkan
                                                    
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-md btn-primary pull-right"
                                                            disabled={this.state.isButtonLoading && "disabled"}
                                                            // onClick={this.handleSubmit}
                                                            onClick={() => {
                                                                this.toggleModalTetapan();
                                                            }}
                                                        >
                                                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                                                        </button>
                                                </div>

                                                <SelectPanel
                                                    options={dataSisAllTetapan}
                                                    onSelectedChanged={this.handleSelectedChangedTetapan}
                                                    hasSelectAll
                                                    focusIndex={1}
                                                    selected={partRemedtetapan}
                                                    disableSearch={false}
                                                />
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>

                    </div>
                </div>
			</div>
		);
	}
}

export default Penetapan;



// WEBPACK FOOTER //
// ./src/views/MasterIuran/Penetapan.js